'use client';

import { useEffect } from 'react';
import { overlay, useBreakPoints } from '@wci-tech/core-ui';
import { useThemeMode } from '@/context';

const Loader = () => {
  const { isDark } = useThemeMode();
  const { isMobile, isTablet } = useBreakPoints();

  const loaderSize = isMobile ? 120 : isTablet ? 160 : 260;

  useEffect(() => {
    const id = overlay.showLoader('fullscreen', {
      loadingText: '',
      customLoaderProps: {
        lottieSrc: isDark
          ? '/animations/darkLottieLoader.lottie'
          : '/animations/lightLottieLoader.lottie',
        loaderType: 'lottie',
        size: loaderSize,
      },
    });

    return () => overlay.hideLoader(id);
  }, []);

  return null;
};

export default Loader;
